import React from 'react'
import { Component } from 'reflux'
import { SubProductGroupActions, SubProductGroupStore, STATUS } from 'Stores/subProductGroupStore'
import { Button, Form, Input, Row, Col, Label } from 'reactstrap'
import _ from 'lodash'
import CollapsibleCard from 'Components/collapsibleCard'
import { Redirect } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export default class SubProductGroupForm extends Component {
  constructor(props) {
    super(props)
    this.stores = [SubProductGroupStore]
    this.storeKeys = ['status', 'subProductGroupDetails']
  }

  resetSubProductGroup = () => {
    if (_.get(this.props, 'match.params.SubProductGroupID')) {
      SubProductGroupActions.getSubProductGroupDetails(this.props.match.params.SubProductGroupID)
    } else {
      SubProductGroupActions.createEmptySubProductGroup()
    }
  }

  render() {
    if (this.state.status === STATUS.REDIRECT) {
      return <Redirect to='/subProductGroups' />
    }
    if (this.state.status === STATUS.IS_FETCHING) {
      return <FontAwesomeIcon icon='spinner' spin />
    }
    return (
      <>
        <CollapsibleCard startOpen header={<strong>{_.get(this.props, 'match.params.SubProductGroupID') ? 'Detaljer' : 'Opret'}</strong>}>
          <Form>
            <Row className='mb-2'>
              <Col xs='2'>
                <Label for='SubProductGroupName'>Navn</Label>
              </Col>
              <Col xs='10'>
                <Input
                  type='text'
                  value={this.state.subProductGroupDetails.SubProductGroupName}
                  name='SubProductGroupName'
                  id='SubProductGroupName'
                  onChange={SubProductGroupActions.updateSubProductGroupField}
                />
              </Col>
            </Row>

            <Button
              onClick={SubProductGroupActions.saveSubProductGroup}
              disabled={this.state.status === STATUS.IS_SAVING || !this.state.subProductGroupDetails.SubProductGroupName.length}
            >
              {this.state.status === STATUS.IS_SAVING ? <FontAwesomeIcon icon='spinner' spin /> : 'Gem'}
            </Button>
            <Button color='danger' onClick={this.resetSubProductGroup} className='ml-2'>
              Nulstil
            </Button>
          </Form>
        </CollapsibleCard>
      </>
    )
  }
}
